import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, CreateAutoBalanceDialogueHandler } from '../types';
import CreateAutoBalanceDialogueContext from './CreateTransferContext';

const { ConfirmationDialogue } = vp;

type AutoBalanceTransferDialogueProps = {
  handleDialogue: DialogueHandler<CreateAutoBalanceDialogueHandler>;
};

type FC = FunctionComponent<AutoBalanceTransferDialogueProps>;

const AutoBalanceTransferDialogue: FC = ({ handleDialogue }: AutoBalanceTransferDialogueProps) => {
  const { showCreateAutoBalanceErrorAlert, createAutoBalanceError } = useContext(CreateAutoBalanceDialogueContext);

  return useMemo(
    () => (
      <div>
        {/* Create Auto Balance Transfer Error */}
        <ConfirmationDialogue
          isVisible={showCreateAutoBalanceErrorAlert}
          title="Error! This Auto Balance Transfer was not created."
          status="error"
          subTitle={`${createAutoBalanceError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'confirm', state: 'fail' }),
          }}
        />
      </div>
    ),
    [showCreateAutoBalanceErrorAlert, createAutoBalanceError],
  );
};

export default AutoBalanceTransferDialogue;
